import { Select, SelectContent, SelectItem, SelectTrigger, SelectValue } from "@/components/ui/select";

export const FieldSelect = ({ value, onChange, options, placeholder = "Pilih", testid, className = "", allLabel }) => (
  <Select value={value === "" || value == null ? (allLabel ? "__all" : undefined) : String(value)} onValueChange={(v) => onChange(v === "__all" ? "" : v)}>
    <SelectTrigger className={`bg-white ${className}`} data-testid={testid}>
      <SelectValue placeholder={placeholder} />
    </SelectTrigger>
    <SelectContent className="max-h-72">
      {allLabel && <SelectItem value="__all">{allLabel}</SelectItem>}
      {options.map((o) => {
        const v = typeof o === "object" ? o.value : o;
        const l = typeof o === "object" ? o.label : o;
        return (
          <SelectItem key={v} value={String(v)} data-testid={testid ? `${testid}-opt-${String(v).replace(/[^a-zA-Z0-9]/g, "-")}` : undefined}>
            {l}
          </SelectItem>
        );
      })}
    </SelectContent>
  </Select>
);
